// Index léger des 102 départements (Arts Divinatoires et Pratiques Énergétiques
// partagent la même liste). Ne contient QUE les champs nécessaires à la barre
// de recherche autocomplete → évite d'importer le monolithe (1.4 MB) dans
// chaque page département.
//
// Auto-généré depuis `departementsArtsDivData.js` par
// /app/scripts/split_departement_data.js — NE PAS ÉDITER À LA MAIN.

export const DEPARTEMENTS_INDEX = [
  { code: "01", name: "Ain", slug: "01-ain" },
  { code: "02", name: "Aisne", slug: "02-aisne" },
  { code: "03", name: "Allier", slug: "03-allier" },
  { code: "04", name: "Alpes-de-Haute-Provence", slug: "04-alpes-de-haute-provence" },
  { code: "05", name: "Hautes-Alpes", slug: "05-hautes-alpes" },
  { code: "06", name: "Alpes-Maritimes", slug: "06-alpes-maritimes" },
  { code: "07", name: "Ardèche", slug: "07-ardeche" },
  { code: "08", name: "Ardennes", slug: "08-ardennes" },
  { code: "09", name: "Ariège", slug: "09-ariege" },
  { code: "10", name: "Aube", slug: "10-aube" },
  { code: "11", name: "Aude", slug: "11-aude" },
  { code: "12", name: "Aveyron", slug: "12-aveyron" },
  { code: "13", name: "Bouches-du-Rhône", slug: "13-bouches-du-rhone" },
  { code: "14", name: "Calvados", slug: "14-calvados" },
  { code: "15", name: "Cantal", slug: "15-cantal" },
  { code: "16", name: "Charente", slug: "16-charente" },
  { code: "17", name: "Charente-Maritime", slug: "17-charente-maritime" },
  { code: "18", name: "Cher", slug: "18-cher" },
  { code: "19", name: "Corrèze", slug: "19-correze" },
  { code: "2A", name: "Corse-du-Sud", slug: "2a-corse-du-sud" },
  { code: "2B", name: "Haute-Corse", slug: "2b-haute-corse" },
  { code: "21", name: "Côte-d'Or", slug: "21-cote-dor" },
  { code: "22", name: "Côtes-d'Armor", slug: "22-cotes-darmor" },
  { code: "23", name: "Creuse", slug: "23-creuse" },
  { code: "24", name: "Dordogne", slug: "24-dordogne" },
  { code: "25", name: "Doubs", slug: "25-doubs" },
  { code: "26", name: "Drôme", slug: "26-drome" },
  { code: "27", name: "Eure", slug: "27-eure" },
  { code: "28", name: "Eure-et-Loir", slug: "28-eure-et-loir" },
  { code: "29", name: "Finistère", slug: "29-finistere" },
  { code: "30", name: "Gard", slug: "30-gard" },
  { code: "31", name: "Haute-Garonne", slug: "31-haute-garonne" },
  { code: "32", name: "Gers", slug: "32-gers" },
  { code: "33", name: "Gironde", slug: "33-gironde" },
  { code: "34", name: "Hérault", slug: "34-herault" },
  { code: "35", name: "Ille-et-Vilaine", slug: "35-ille-et-vilaine" },
  { code: "36", name: "Indre", slug: "36-indre" },
  { code: "37", name: "Indre-et-Loire", slug: "37-indre-et-loire" },
  { code: "38", name: "Isère", slug: "38-isere" },
  { code: "39", name: "Jura", slug: "39-jura" },
  { code: "40", name: "Landes", slug: "40-landes" },
  { code: "41", name: "Loir-et-Cher", slug: "41-loir-et-cher" },
  { code: "42", name: "Loire", slug: "42-loire" },
  { code: "43", name: "Haute-Loire", slug: "43-haute-loire" },
  { code: "44", name: "Loire-Atlantique", slug: "44-loire-atlantique" },
  { code: "45", name: "Loiret", slug: "45-loiret" },
  { code: "46", name: "Lot", slug: "46-lot" },
  { code: "47", name: "Lot-et-Garonne", slug: "47-lot-et-garonne" },
  { code: "48", name: "Lozère", slug: "48-lozere" },
  { code: "49", name: "Maine-et-Loire", slug: "49-maine-et-loire" },
  { code: "50", name: "Manche", slug: "50-manche" },
  { code: "51", name: "Marne", slug: "51-marne" },
  { code: "52", name: "Haute-Marne", slug: "52-haute-marne" },
  { code: "53", name: "Mayenne", slug: "53-mayenne" },
  { code: "54", name: "Meurthe-et-Moselle", slug: "54-meurthe-et-moselle" },
  { code: "55", name: "Meuse", slug: "55-meuse" },
  { code: "56", name: "Morbihan", slug: "56-morbihan" },
  { code: "57", name: "Moselle", slug: "57-moselle" },
  { code: "58", name: "Nièvre", slug: "58-nievre" },
  { code: "59", name: "Nord", slug: "59-nord" },
  { code: "60", name: "Oise", slug: "60-oise" },
  { code: "61", name: "Orne", slug: "61-orne" },
  { code: "62", name: "Pas-de-Calais", slug: "62-pas-de-calais" },
  { code: "63", name: "Puy-de-Dôme", slug: "63-puy-de-dome" },
  { code: "64", name: "Pyrénées-Atlantiques", slug: "64-pyrenees-atlantiques" },
  { code: "65", name: "Hautes-Pyrénées", slug: "65-hautes-pyrenees" },
  { code: "66", name: "Pyrénées-Orientales", slug: "66-pyrenees-orientales" },
  { code: "67", name: "Bas-Rhin", slug: "67-bas-rhin" },
  { code: "68", name: "Haut-Rhin", slug: "68-haut-rhin" },
  { code: "69", name: "Rhône", slug: "69-rhone" },
  { code: "70", name: "Haute-Saône", slug: "70-haute-saone" },
  { code: "71", name: "Saône-et-Loire", slug: "71-saone-et-loire" },
  { code: "72", name: "Sarthe", slug: "72-sarthe" },
  { code: "73", name: "Savoie", slug: "73-savoie" },
  { code: "74", name: "Haute-Savoie", slug: "74-haute-savoie" },
  { code: "75", name: "Paris", slug: "75-paris" },
  { code: "76", name: "Seine-Maritime", slug: "76-seine-maritime" },
  { code: "77", name: "Seine-et-Marne", slug: "77-seine-et-marne" },
  { code: "78", name: "Yvelines", slug: "78-yvelines" },
  { code: "79", name: "Deux-Sèvres", slug: "79-deux-sevres" },
  { code: "80", name: "Somme", slug: "80-somme" },
  { code: "81", name: "Tarn", slug: "81-tarn" },
  { code: "82", name: "Tarn-et-Garonne", slug: "82-tarn-et-garonne" },
  { code: "83", name: "Var", slug: "83-var" },
  { code: "84", name: "Vaucluse", slug: "84-vaucluse" },
  { code: "85", name: "Vendée", slug: "85-vendee" },
  { code: "86", name: "Vienne", slug: "86-vienne" },
  { code: "87", name: "Haute-Vienne", slug: "87-haute-vienne" },
  { code: "88", name: "Vosges", slug: "88-vosges" },
  { code: "89", name: "Yonne", slug: "89-yonne" },
  { code: "90", name: "Territoire de Belfort", slug: "90-territoire-de-belfort" },
  { code: "91", name: "Essonne", slug: "91-essonne" },
  { code: "92", name: "Hauts-de-Seine", slug: "92-hauts-de-seine" },
  { code: "93", name: "Seine-Saint-Denis", slug: "93-seine-saint-denis" },
  { code: "94", name: "Val-de-Marne", slug: "94-val-de-marne" },
  { code: "95", name: "Val-d'Oise", slug: "95-val-doise" },
  { code: "971", name: "Guadeloupe", slug: "971-guadeloupe" },
  { code: "972", name: "Martinique", slug: "972-martinique" },
  { code: "973", name: "Guyane", slug: "973-guyane" },
  { code: "974", name: "La Réunion", slug: "974-la-reunion" },
  { code: "976", name: "Mayotte", slug: "976-mayotte" },
];

/** Recherche un département par code ou nom (insensible aux accents/casse). */
const _normalize = (s) =>
  (s || "").toString().toLowerCase().normalize("NFD").replace(/[\u0300-\u036f]/g, "");

export function lookupDept(rawQuery) {
  const q = _normalize(rawQuery).trim();
  if (!q) return null;
  // 1. code exact
  const byCode = DEPARTEMENTS_INDEX.find((d) => _normalize(d.code) === q);
  if (byCode) return byCode;
  // 2. nom (préfixe)
  const byName = DEPARTEMENTS_INDEX.find((d) => _normalize(d.name).startsWith(q));
  if (byName) return byName;
  // 3. code + nom (contains)
  return DEPARTEMENTS_INDEX.find((d) => _normalize(`${d.code} ${d.name}`).includes(q)) || null;
}
